// ResetTable.tsx
import React, { useEffect, useState } from 'react';
import { Modal, Button, Form} from 'react-bootstrap';
import { Mesa} from '../../../../../../../types';
import {  resetTable } from '../../../../../../../../../../crud/pedidos_api/pedidos';
import { getAutoPrintCancellationComandas } from '../../../../../../../../../../crud/localDB/pedidosConfig';
import { toast } from 'react-toastify';
import {  X } from 'react-bootstrap-icons';
import './ResetTable.scss';


interface ResetTableProps {
  mesa: Mesa;
  show: boolean;
  onClose: () => void;
}

const ResetTable: React.FC<ResetTableProps> = ({ mesa, show, onClose }) => {
  const [comment, setComment] = useState('');
  const [resetting, setResetting] = useState(false);
  const [printToKitchen, setPrintToKitchen] = useState(false);
  const [autoPrintCancellationComandas, setAutoPrintCancellationComandas] = useState(false);

  useEffect(() => {
    let isMounted = true;

    getAutoPrintCancellationComandas()
      .then((value) => {
        if (!isMounted) return;
        setAutoPrintCancellationComandas(value);
        if (value) {
          setPrintToKitchen(true);
        }
      })
      .catch((error) => {
        console.error('Error loading cancellation comanda config:', error);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  const handleResetTable = async () => {
    if (comment.trim().length < 15) {
      toast.error('El comentario debe tener al menos 15 caracteres');
      return;
    }
    
    setResetting(true);
    try {
      await resetTable(mesa.id, comment.trim(), autoPrintCancellationComandas || printToKitchen);
      toast.success('La mesa se ha reseteado correctamente');
      onClose();
      window.location.reload();
    } catch (error) {
      toast.error('Error al resetear la mesa');
      console.error('Error al resetear la mesa, ID de la mesa reseteada:', mesa.id);
    } finally {
      setResetting(false);
    }
  };


  return (
        <Modal show={show} onHide={() => onClose()} className="reset-table-modal">
            <Modal.Header>
                      <div className='form-modal-title-container'>
                        <Modal.Title className='form-modal-title'>Confirmación</Modal.Title>
                        </div>
                        <Button variant="none" className="modal-close-button" onClick={() => onClose()}>
                          <X size={24} />
                        </Button>
            </Modal.Header>
            <Modal.Body>
                        <p>¿Quieres resetear esta mesa? Al hacer esto, eliminará los pedidos que se hayan realizado y la mesa volverá a quedar libre.</p>
                        <Form.Group className="mt-3">
                          <Form.Label>
                            Comentario <span className="comment-required">*</span>
                          </Form.Label>
                          <Form.Control
                            as="textarea"
                            rows={3}
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            placeholder="Ingresa un comentario (mínimo 15 caracteres)"
                            disabled={resetting}
                            maxLength={500}
                            className="reset-table-comment-textarea"
                          />
                          <Form.Text className="text-muted">
                            {comment.trim().length}/15 caracteres mínimos
                          </Form.Text>
                        </Form.Group>
                        {autoPrintCancellationComandas ? (
                          <div className="print-to-kitchen-toggle text-muted">
                            Se notificará a cocina automáticamente por configuración.
                          </div>
                        ) : (
                          <Form.Group className="print-to-kitchen-toggle">
                            <Form.Check
                              type="switch"
                              id="print-to-kitchen-reset"
                              label="Notificar a cocina"
                              checked={printToKitchen}
                              onChange={(e) => setPrintToKitchen(e.target.checked)}
                              disabled={resetting}
                            />
                          </Form.Group>
                        )}
            </Modal.Body>
            <Modal.Footer>
              <div className="form-modal-footer-custom">
                        <Button className="form-button-cancel" variant="none" onClick={() => onClose()} disabled={resetting}>
                          Cancelar
                        </Button>
                        <Button 
                          className="form-button-create" 
                          variant="none" 
                          onClick={handleResetTable}
                          disabled={resetting || comment.trim().length < 15}
                        >
                          {resetting ? 'Reseteando...' : 'Resetear'}
                        </Button>
                        </div>
             </Modal.Footer>
              </Modal>
  );
};

export default ResetTable;
